import type { Catalog } from "../en";

/** Billing screen (tenant/billing.html). */
export const billing: Catalog["billing"] = {
  title: "Billing at Paggamit",
  subtitle: "Ang inyong plano, ang nagamit ninyo ngayong cycle ({{cycle}}), at mga opisyal na resibo.",
  cycleRange: "{{start}} – {{end}}",
  exportUsage: "I-export ang paggamit",
  upgradePlan: "Mag-upgrade ng plano",
  perMonth: "/ buwan",
  perYear: "/ taon",
  loadError: "Hindi ma-load ang billing.",
  loadErrorBody: "Ligtas ang inyong plano at mga bayad. Subukan muli mamaya.",
  gateway: {
    legend: "Magbayad gamit ang",
    paymongo: "GCash, Maya o card",
    stripe: "Card",
    paypal: "PayPal",
    hint_paymongo: "Secure na checkout ng PayMongo",
    hint_stripe: "Visa, Mastercard, Amex, Apple Pay o Google Pay · secure na checkout ng Stripe",
    hint_paypal: "PayPal balance o card sa iyong PayPal account",
    name_paymongo: "PayMongo",
    name_stripe: "Stripe",
    name_paypal: "PayPal",
    save: "Itago ang paraang ito para sa renewal",
    saveHint: "Ligtas na itinatago ng payment provider; maaari mo itong alisin anumang oras sa Paraan ng pagbabayad.",
    testMode: "Test mode — walang totoong perang sisingilin.",
  },
  region: {
    changeBanner: "Magiging {{currency}} ang iyong billing currency mula {{current}} sa {{date}}, pagsisimula ng susunod na billing period.",
  },
  gate: {
    badge: "Kailangang mag-upgrade",
    upgrade: "Tingnan ang mga plano",
    title: "Hindi available ang billing sa workspace na ito",
    body: "Hilingin sa CRUD.IT na i-enable ang self-serve billing para sa inyong plano.",
  },
  status: {
    active: "Aktibo",
    trialing: "Trial",
    past_due: "Lampas na sa due",
    paused: "Naka-pause",
    canceled: "Kinansela",
  },
  plan: {
    current: "Kasalukuyang plano",
    billedMonthly: "Buwanang singil",
    billedAnnually: "Taunang singil",
    renews: "magre-renew sa",
    notIncluded: "{{features}}: {{plan}}",
    change: "Palitan ang plano",
    switchAnnual: "Lumipat sa taunan · makatipid ng 2 buwan",
    annualActive: "Taunang singil",
    graceUntil: "Naubos na ang mga mensahe ngayong cycle. Sasagot pa rin ang assistant hanggang {{date}}, pagkatapos ay hihilingin sa mga bisita na direktang makipag-ugnayan sa inyo. Mag-top up o mag-upgrade para tuloy-tuloy.",
    scheduled: "Magiging {{plan}} ang inyong plano sa {{date}}.",
    scheduledCredit: "Mapupunta sa susunod na invoice ang {{amount}} na credit.",
    keepPlan: "Panatilihin ang plano",
    scheduledCancelled: "Kinansela ang nakaiskedyul na pagbabago. Mananatili kayo sa kasalukuyang plano.",
  },
  usage: {
    title: "Paggamit ngayong cycle",
    cycle: "Araw {{day}} ng {{days}} · magre-reset sa {{date}}",
    projectedLabel: "Tantiya:",
    projected_one: "~{{value}} mensahe",
    projected_other: "~{{value}} mensahe",
    messages: "Mga mensahe",
    agents: "Mga agent",
    storage: "Storage ng kaalaman",
    seats: "Mga seat",
    playground: "Mga test na mensahe sa Playground",
    playgroundHint: "Hiwalay na pool para sa pag-test sa Playground; hindi binabawas sa inyong allowance.",
    workflowRuns: "Mga workflow run",
    workflowRunsHint: "Mga run ngayong buwan. Kapag lumampas sa limit, lalaktawan ng mga background workflow; may 10% na palugit muna ang mga customer-facing.",
    voice: "Minuto ng boses",
    notOnPlan: "Wala sa plano",
    unlimited: "Walang limitasyon",
    remaining: "{{value}} pa ang natitira ngayong cycle",
    overPace: "Malamang lumampas ng ~{{value}} bago ang {{date}}",
    addSeats: "Magdagdag ng seat",
    perSeat: "sa halagang {{price}}/seat/buwan",
    perSeat_year: "sa halagang {{price}}/seat/taon",
    addStorage: "Magdagdag ng storage",
    perGb: "sa halagang {{price}}/GB/buwan",
    perGb_year: "sa halagang {{price}}/GB/taon",
    overageTitle: "Patakaran sa overage:",
    overageBody: "kapag naabot ang {{value}} na mensahe, sasagot pa rin ang agent sa loob ng 24 oras at mag-e-email kami sa Owner. Pagkatapos noon, makikita ng mga bisita ang \"Makipag-ugnayan po sa amin nang direkta\" hanggang mag-top up, mag-upgrade, o mag-reset ang cycle.",
  },
  topup: {
    title: "Auto top-up",
    pack: "{{price}} bawat {{credits}} dagdag na mensahe",
    settingsTitle: "Settings ng auto top-up",
    packs: "Pack bawat top-up",
    packsHint: "1 hanggang {{max}} pack bawat beses.",
    packsError: "Pumili ng 1 hanggang {{max}} pack.",
    threshold: "Mag-top up kapag mas kaunti sa",
    thresholdHint: "Natitirang mensahe sa cycle.",
    cap: "Buwanang limit sa gastos ({{currency}})",
    capHint: "Opsyonal. Iwanang blangko kung walang limit.",
    numberError: "Maglagay ng tamang numero.",
    grace: "24 oras na overage grace",
    graceHint: "Patuloy na sumagot sa loob ng 24 oras matapos maubos ang allowance.",
    saveOn: "I-save at i-on",
    on: "Naka-on ang auto top-up",
    off: "Na-off ang auto top-up",
  },
  plans: {
    title: "Mga plano",
    subtitleExclusive: "Presyo sa {{currency}}, bago ang buwis (idinadagdag ang {{tax}} sa invoice). May opisyal na resibo sa bawat bayad.",
    subtitleOther: "Presyo sa {{currency}} · {{tax}}. May opisyal na resibo sa bawat bayad.",
    period: "Panahon ng singil",
    monthly: "Buwanan",
    yearly: "Taunan",
    yearlyFree_one: "Taunan · {{count}} buwang libre",
    yearlyFree_other: "Taunan · {{count}} buwang libre",
    current: "Kasalukuyang plano",
    recommended: "Inirerekomenda",
    custom: "Custom",
    customVolume: "Custom na dami at seat",
    messages: "{{value}} mensahe / buwan",
    agents_one: "{{count}} agent",
    agents_other: "{{count}} agent",
    storage: "{{value}} na kaalaman",
    seats_one: "{{count}} seat",
    seats_other: "{{count}} seat",
    yourPlan: "Inyong plano",
    upgradeTo: "Mag-upgrade sa {{plan}}",
    downgrade: "Mag-downgrade",
    switchYearly: "Lumipat sa taunan",
    switchMonthly: "Lumipat sa buwanan",
    contactSales: "Kausapin ang sales",
    payManually: "Magbayad nang manu-mano / kausapin ang sales",
    salesSubject: "Tanong tungkol sa {{plan}} plan",
    tagline_starter: "Maliliit na organisasyong nagsisimula",
    tagline_standard: "Karamihan ng lumalagong organisasyon",
    tagline_pro: "Maraming sangay at mas malalaking team",
    tagline_institution: "Malalaking institusyon, LGU at network",
  },
  features: {
    widget: "Website widget",
    webapp: "web app",
    messenger: "Facebook Messenger",
    actions: "Mga aksyon",
    helpdesk: "helpdesk inbox",
    api: "API",
    custom_roles: "custom na role",
    evaluations: "mga ebalwasyon",
    mobile_white_label: "mobile app",
    remove_branding: "white-label na widget",
    sso: "SSO",
    secure_launch: "Secure launch",
    secure_launch_facts: "customer facts sa chat",
    after_sales: "after-sales desk",
    commerce: "mga order at catalogue",
    commerce_presets: "commerce presets",
    connectors: "connector",
    workflows: "workflow",
    graph_retrieval: "paghahanap sa knowledge graph",
    customer_success_manager: "Sariling success manager",
    private_deployment: "Opsyong on-prem / private deployment",
    sla: "99.9% uptime SLA",
  },
  limits: {
    messages: "{{value}} mensahe",
    agents: "{{value}} agent",
    storage: "{{value}} na kaalaman",
    seats: "{{value}} seat",
  },
  change: {
    titleUpgrade: "Mag-upgrade sa {{plan}}",
    titleDowngrade: "Mag-downgrade sa {{plan}}",
    titleInterval: "Gawing taunan ang singil ng {{plan}}",
    upgradeBody: "Makukuha ninyo agad ang {{limits}}.",
    downgradeBody: "Pinapayagan ng {{plan}} ang {{agents}} agent, {{seats}} seat at {{storage}}. Kasalukuyan kayong gumagamit ng {{usedAgents}} agent, {{usedSeats}} seat at {{usedStorage}}.",
    downgradeOver: "Ipa-pause ang mga agent at miyembrong lampas sa limit kapag nagkabisa ang pagbabago.",
    intervalBody: "Magbayad ng {{price}} isang beses kada taon sa halip na {{monthly}} kada buwan. Magsisimula ang taunang termino kapag pumasok na ang bayad.",
    newPrice: "Bagong presyo",
    chargedTo: "Sisingilin sa",
    hostedCheckout_paymongo: "Secure na checkout (GCash, Maya o card)",
    hostedCheckout_stripe: "Secure na card checkout (Stripe)",
    hostedCheckout_paypal: "PayPal",
    prorationNote: "Prorated: {{amount}} + {{tax}} {{taxLabel}} ang sisingilin ngayon para sa natitirang {{days}} araw ng cycle. Idadagdag agad ang {{credits}} na dagdag na mensahe.",
    prorationNoteNoTax: "Prorated: {{amount}} ang sisingilin ngayon para sa natitirang {{days}} araw ng cycle. Idadagdag agad ang {{credits}} na dagdag na mensahe.",
    trialNote: "Magtatapos ang libreng trial at magsisimula ngayon ang {{plan}}: {{amount}} + {{tax}} {{taxLabel}} ang sisingilin ngayon para sa unang period. Kasama ang {{credits}} na mensahe.",
    trialNoteNoTax: "Magtatapos ang libreng trial at magsisimula ngayon ang {{plan}}: {{amount}} ang sisingilin ngayon para sa unang period. Kasama ang {{credits}} na mensahe.",
    restartNote: "Magsisimula ulit ngayon ang billing period sa {{plan}}: {{amount}} + {{tax}} {{taxLabel}} ang sisingilin ngayon, matapos i-credit ang {{credit}} para sa hindi nagamit na panahon. Kasama ang {{credits}} na mensahe.",
    restartNoteNoTax: "Magsisimula ulit ngayon ang billing period sa {{plan}}: {{amount}} ang sisingilin ngayon, matapos i-credit ang {{credit}} para sa hindi nagamit na panahon. Kasama ang {{credits}} na mensahe.",
    downgradeNote: "Magkakabisa sa {{date}}. Walang refund sa kasalukuyang cycle; mapupunta sa susunod na invoice ang {{credit}} na credit.",
    previewError: "Hindi namin makalkula ang pagbabago sa presyo.",
    confirmUpgrade: "Mag-upgrade ngayon",
    confirmDowngrade: "Mag-downgrade sa {{date}}",
    confirmInterval: "Magpatuloy sa pagbabayad",
    upgradedToast: "Na-upgrade sa {{plan}}. Aktibo na ang bagong limit.",
    scheduledToast: "Nakaiskedyul ang downgrade sa {{plan}} sa {{date}}",
  },
  checkout: {
    redirecting: "Inililipat sa secure na bayaran…",
    unavailable: "Pansamantalang hindi available ang pagbabayad. Subukan muli.",
    paid: "Natanggap ang bayad. Salamat!",
    failed: "Hindi natuloy ang bayad. Walang nasingil.",
    returnSuccess: "Natanggap ang bayad. Ipapadala sa email ang inyong resibo.",
    returnCancelled: "Kinansela ang bayad. Walang nasingil.",
    confirmPending: "Kinukumpirma ang iyong bayad. Mag-a-update ang page na ito kapag pumasok na.",
    devTitle: "Test na bayad",
    devBody: "Test mode ang pagbabayad sa environment na ito. Piliin kung paano matatapos ang checkout.",
    amount: "Halaga",
    devPay: "Magbayad",
    devFail: "Gayahin ang pagkabigo",
  },
  addons: {
    title: "Mga add-on",
    subtitle: "Dagdag na kapasidad sa ibabaw ng plano, kasama sa singil ng subscription",
    none: "Wala pang add-on.",
    add: "Idagdag",
    cancel: "Kanselahin",
    cancelled: "Kinansela ang add-on. Aktibo pa ito hanggang matapos ang cycle.",
    ending: "Matatapos",
    endsOn: "matatapos sa {{date}}",
    oneTime: "isang beses",
    subtotal: "Subtotal",
    orUpgrade: "O mag-upgrade",
    seatsIncluded: "{{plan}} · kasama ang {{count}} seat",
    upgrade: "I-upgrade",
    replacesLite: "Agad na pinapalitan ng Plus ang Secure launch Lite. Ikino-credit sa invoice na ito ang hindi nagamit na bahagi ng Lite sa kasalukuyang billing period.",
    compare: {
      title: "Paghambingin ang Secure launch Lite at Plus",
      subtitle: "Parehong naihahatid ng sarili ninyong portal ang mga naka-sign-in na customer sa chat. Ginagamit din ng Plus ang alam ninyo tungkol sa kanila.",
      col_what: "Ano ang makukuha",
      col_lite: "Lite",
      col_plus: "Plus",
      current: "Kasalukuyan",
      included: "Kasama",
      notIncluded: "Hindi kasama",
      row_month: "Kada buwan",
      row_year: "Kada taon",
      yearHint: "Dalawang buwang libre",
      row_launch: "Launch na naka-sign-in",
      launchHint: "One-time code na minsan lang magagamit, limitasyon ng session, revoke.",
      row_named: "\"Chatting as\" at history",
      namedHint: "Ipinapakita ng chat ang pangalan ng customer at pinagsasama ang mga chat niya ayon sa customer reference.",
      row_facts: "Customer facts",
      factsHint: "Tier, katayuan ng account at mga attribute na ginagamit ng AI, ng mga flow, priority routing at compliance branch.",
      row_volume: "Launch kada buwan",
      volumeLite: "{{limit}} kada workspace",
      volumePlus: "Walang limitasyon",
      row_plans: "Mga plan",
      plansBoth: "Standard at Pro",
      footnote: "Hindi kasama ang VAT sa mga presyo. Kasama ang Plus sa Institution nang walang bayad. Pinapalitan ng pagbili ng Plus ang Lite at ikino-credit ang hindi nagamit na oras nito.",
    },
    dueNowDays: "Prorated: {{days}} sa {{total}} araw ang natitira",
    renews_month: "Sisingilin ngayon. Nagre-renew buwan-buwan kasama ng inyong plan.",
    renews_year: "Sisingilin ngayon para sa buong taon. Nagre-renew taon-taon sa {{price}} bawat unit.",
    renews_year_prorated: "Sisingilin ngayon para sa natitirang {{days}} araw ng inyong taon. Nagre-renew taon-taon sa {{price}} bawat unit.",
    name_message_pack: "Message pack",
    name_extra_agent: "Dagdag na agent",
    name_extra_seat: "Dagdag na seat",
    name_remove_branding: "Alisin ang branding",
    name_knowledge_storage_1gb: "Dagdag na knowledge storage (+1 GB)",
    name_secure_launch_lite: "Secure launch Lite",
    name_secure_launch: "Secure launch Plus",
    price_message_pack: "{{price}} bawat 2,000 mensahe",
    price_extra_agent: "{{price}} / agent / buwan",
    price_extra_seat: "{{price}} / seat / buwan",
    price_remove_branding: "{{price}} / buwan",
    price_knowledge_storage_1gb: "{{price}} / GB / buwan",
    price_extra_agent_year: "{{price}} / agent / taon",
    price_extra_seat_year: "{{price}} / seat / taon",
    price_remove_branding_year: "{{price}} / taon",
    price_knowledge_storage_1gb_year: "{{price}} / GB / taon",
    price_secure_launch_lite: "{{price}} / buwan · 2,000 launch",
    price_secure_launch: "{{price}} / buwan · walang limitasyon ang launch",
    price_secure_launch_lite_year: "{{price}} / taon · 2,000 launch kada buwan",
    price_secure_launch_year: "{{price}} / taon · walang limitasyon ang launch",
    title_extra_seat: "Magdagdag ng seat",
    title_message_pack: "Bumili ng message pack",
    title_extra_agent: "Magdagdag ng agent",
    title_remove_branding: "Alisin ang branding",
    title_knowledge_storage_1gb: "Magdagdag ng knowledge storage",
    title_secure_launch_lite: "Idagdag ang Secure launch Lite",
    title_secure_launch: "Idagdag ang Secure launch Plus",
    quantity_extra_seat: "Dagdag na seat",
    quantity_message_pack: "Pack ng 2,000 mensahe",
    quantity_extra_agent: "Dagdag na agent",
    quantity_remove_branding: "Dami",
    quantity_knowledge_storage_1gb: "Dagdag na storage",
    quantity_secure_launch_lite: "Dami",
    quantity_secure_launch: "Dami",
    unit_extra_seat: "Bawat seat",
    unit_message_pack: "Bawat pack",
    unit_extra_agent: "Bawat agent",
    unit_remove_branding: "Presyo",
    unit_knowledge_storage_1gb: "Bawat +1 GB",
    unit_secure_launch_lite: "Presyo",
    unit_secure_launch: "Presyo",
    body_extra_seat: "Magdagdag ng seat para sa mas maraming miyembro ng team.",
    body_message_pack: "Dagdag na mensahe para sa cycle na ito.",
    body_extra_agent: "Magpatakbo ng mas maraming assistant nang sabay.",
    body_remove_branding: "Itago ang linyang \"Powered by\" sa widget at web app.",
    body_knowledge_storage_1gb: "Mas maraming espasyo para sa mga file, pahina, at teksto na pinagkukunan ng sagot ng inyong mga assistant. Kapag inalis ito sa susunod, walang mabubura sa naidagdag na; hindi lang makakapagdagdag habang lampas sa limit.",
    body_secure_launch_lite: "Hayaang ihatid ng sarili ninyong portal ang mga naka-sign-in na customer diretso sa chat, may pangalan na at magkakasama ang mga chat nila. Hanggang 2,000 launch kada buwan. Hindi kasama ang customer facts (tier, katayuan ng account, attribute).",
    body_secure_launch: "Lahat ng nasa Lite, dagdag ang customer facts: umaabot ang tier, katayuan ng account at mga attribute sa AI, sa inyong mga flow, priority routing at compliance branch. Walang limitasyon ang launch. Kasama sa Institution.",
    confirm_extra_seat: "Magdagdag ng seat",
    confirm_message_pack: "Bumili ng pack",
    confirm_extra_agent: "Magdagdag ng agent",
    confirm_remove_branding: "Alisin ang branding",
    confirm_knowledge_storage_1gb: "Magdagdag ng storage",
    confirm_secure_launch_lite: "Idagdag ang Secure launch Lite",
    confirm_secure_launch: "Idagdag ang Secure launch Plus",
    bought_extra_seat_one: "Nadagdag ang {{count}} seat",
    bought_extra_seat_other: "Nadagdag ang {{count}} seat",
    bought_message_pack_one: "Nadagdag ang {{count}} message pack",
    bought_message_pack_other: "Nadagdag ang {{count}} message pack",
    bought_extra_agent_one: "Nadagdag ang {{count}} agent slot",
    bought_extra_agent_other: "Nadagdag ang {{count}} agent slot",
    bought_remove_branding: "Inalis ang branding sa widget at web app",
    bought_knowledge_storage_1gb_one: "Nadagdag ang {{count}} GB na knowledge storage",
    bought_knowledge_storage_1gb_other: "Nadagdag ang {{count}} GB na knowledge storage",
    limitReached: "Naabot na ang limit ng workspace na ito",
    capHint: "Hanggang {{max}} GB sa kabuuan; may hawak kayong {{held}} GB. Para sa mas marami, makipag-usap sa sales tungkol sa Institution.",
    capReached: "Hawak na ninyo ang pinakamarami na maaaring bilhin ng workspace na ito ({{max}} GB). Para sa mas marami, makipag-usap sa sales tungkol sa Institution.",
    bought_secure_launch_lite: "Nadagdag ang Secure launch Lite",
    bought_secure_launch: "Nadagdag ang Secure launch Plus",
  },
  methods: {
    title: "Paraan ng pagbabayad",
    paypalOption: "PayPal",
    paypalIntro: "Magbayad gamit ang iyong PayPal account. Aaprubahan mo ito nang isang beses sa PayPal, at iyon na ang sisingilin namin sa bawat renewal at top-up.",
    paypalDefault: "Ito ang magiging default na paraan para sa mga renewal at top-up.",
    paypalContinue: "Magpatuloy sa PayPal",
    paypalUnavailable: "Hindi available ang PayPal ngayon. Subukan ulit mamaya, o makipag-ugnayan sa sales para sa ibang paraan ng pagbabayad.",
    onlyPaypal: "Magbayad gamit ang PayPal",
    otherOptionsBefore: "Iba pang paraan ng pagbabayad:",
    otherOptionsAction: "makipag-ugnayan sa sales",
    legacy: "Naka-save na dati · gagamitin pa rin sa mga renewal hanggang makapagdagdag ka ng PayPal",
    addPaypal: "Magdagdag ng paraan ng pagbabayad",
    setupWait: "Binubuksan ang PayPal…",
    disabledError: "Hindi na iniaalok ang paraang iyon ng pagbabayad. Magbayad gamit ang PayPal, o makipag-ugnayan sa sales para sa ibang paraan.",
    add: "Magdagdag",
    addTitle: "Magdagdag ng paraan ng pagbabayad",
    typeLabel: "Uri ng paraan ng pagbabayad",
    type_gcash: "GCash",
    type_maya: "Maya",
    type_card: "Credit / debit card",
    type_bank: "Bank transfer",
    label_card: "{{brand}} na nagtatapos sa {{last4}}",
    label_gcash: "GCash ••• {{last4}}",
    label_maya: "Maya ••• {{last4}}",
    label_bank: "Bank transfer",
    label_paypal: "PayPal account",
    add_stripe: "Magdagdag ng card",
    add_paypal: "Magdagdag ng PayPal",
    via: "sa {{gateway}}",
    otherCurrency: "Hindi ginagamit para sa kasalukuyang billing currency",
    setupRedirect: "Inililipat ka para i-save ang paraan ng pagbabayad…",
    setupLost: "Hindi natapos ang pag-save ng paraan ng pagbabayad. Pakidagdag ulit.",
    setupCancelled: "Kinansela ang pag-save ng paraan ng pagbabayad.",
    expires: "Mag-e-expire sa {{date}}",
    backup: "Backup · gagamitin kung ma-decline ang default",
    defaultHint: "Ginagamit sa renewal at top-up",
    default: "Default",
    makeDefaultAction: "Gawing default",
    defaultSet: "Na-update ang default na paraan ng pagbabayad",
    remove: "Alisin ang {{method}}",
    removed: "Inalis ang paraan ng pagbabayad",
    emptyTitle: "Wala pang paraan ng pagbabayad",
    emptyBody: "Magdagdag ng paraan ng pagbabayad para tuloy-tuloy ang renewal at top-up.",
    cardNumber: "Numero ng card",
    expiry: "Expiry",
    cvc: "CVC",
    mobile_gcash: "Numero ng GCash",
    mobile_maya: "Numero ng Maya",
    mobileHint_gcash: "Aaprubahan ninyo ang ₱1 na beripikasyon sa GCash app. Ire-refund ito agad.",
    mobileHint_maya: "Ililipat kayo sa Maya para i-link ang inyong wallet.",
    bankTitle: "Magbayad sa bank transfer (BDO / BPI / UnionBank / InstaPay)",
    bankBody: "Mag-e-email kami ng invoice na may bank details ng CRUD.IT Solutions Inc. Ipadala ang patunay ng bayad sa billing email na nasa invoice. Aktibo ang plano hanggang 7 araw matapos ang due date.",
    makeDefault: "Gawin itong default na paraan ng pagbabayad",
    save: "I-save ang paraan ng pagbabayad",
    saved: "Na-save ang paraan ng pagbabayad",
    errors: {
      number: "Maglagay ng tamang numero ng card.",
      expiry: "Gamitin ang MM / YY.",
      cvc: "Ilagay ang 3 o 4 na digit na code.",
      mobile: "Maglagay ng PH mobile number (09xx xxx xxxx).",
      tokenize: "Hindi ma-verify ang card. Suriin ang detalye at subukan muli.",
      config: "Hindi ma-load ang mga payment setting kaya hindi pa mase-save ang card.",
    },
  },
  manual: {
    title: "Sinisingil sa pamamagitan ng invoice · pinamamahalaan ng Sagot",
    body: "Ang Sagot ang nag-iinvoice sa workspace na ito sa labas ng produkto, kaya walang babayaran dito at walang card o PayPal account na sinisingil. Para baguhin ang plan, add-on o paraan ng pagbabayad, makipag-ugnayan sa sales.",
    term: "Kasalukuyang termino: {{start}} hanggang {{end}}",
    agreed: "Napagkasunduang presyo ng plan: {{price}}",
    contact: "Kausapin ang sales",
    gated: "Sinisingil sa pamamagitan ng invoice. Makipag-ugnayan sa sales para baguhin ito.",
    methodsTitle: "Sinisingil sa pamamagitan ng invoice",
    methodsBody: "Hindi kailangan ng paraan ng pagbabayad. Ang Sagot ang magpapadala ng invoice at mamamahala ng mga renewal para sa iyo.",
    badge: "Naka-invoice",
  },
  salesRequest: {
    title: "Kausapin ang sales",
    subtitle: "Sabihin ang kailangan mo at sasagot kami sa email. Puwede ka naming i-invoice sa halip na singilin sa PayPal.",
    plan: "Plan",
    planNone: "Walang plan, mga add-on lang",
    addons: "Mga add-on",
    addonsHint: "Piliin ang gusto mo bukod sa plan.",
    seats: "Mga seat",
    seatsHint: "Ilang tao ang gagamit ng workspace? (opsyonal)",
    cycle: "Billing cycle",
    monthly: "Buwanan",
    annual: "Taunan",
    notes: "Mga tala",
    notesHint: "Purchase order, paano mo gustong magbayad, at iba pa.",
    contactName: "Pangalan mo",
    contactEmail: "Email",
    contactPhone: "Telepono (opsyonal)",
    send: "Ipadala ang request",
    loadError: "Hindi namin ma-load ang mga plan at add-on. Maaari mo pa ring ilarawan ang kailangan mo sa mga tala.",
    sendError: "Hindi naipadala ang request mo. Nandito pa ang mga sagot mo; subukan ulit.",
    errors: {
      name: "Ilagay ang pangalan mo.",
      email: "Maglagay ng wastong email address.",
      phone: "Gumamit ng numero, espasyo, + o -.",
      nothing: "Pumili ng plan o mga add-on, o sabihin sa mga tala ang kailangan mo.",
      seats: "Maglagay ng buong numero mula 1 hanggang 10,000.",
    },
    sent: {
      title: "Naipadala na ang request",
      body: "Salamat. Mag-eemail sa {{email}} ang aming sales team sa lalong madaling panahon.",
      reference: "Sanggunian SR-{{number}}",
      noMail: "Naka-save ang request mo. Hindi nakapadala ang email notice sa sales, pero makikita pa rin nila ito.",
      done: "Tapos na",
    },
    history: {
      title: "Mga sales request mo",
      status_new: "Bago",
      status_contacted: "Nakontak na",
      status_done: "Tapos na",
      row: "SR-{{number}} · {{plan}}",
      noPlan: "Mga add-on lang",
    },
  },
  details: {
    title: "Detalye ng billing",
    subtitle: "Nakalimbag sa mga opisyal na resibo (rehistrado sa BIR)",
    edit: "I-edit",
    registeredName: "Rehistradong pangalan",
    tin: "TIN",
    tinHint: "hal. 008-412-773-000",
    receiptEmail: "Email para sa resibo",
    receiptsTo: "Ipinapadala ang resibo sa",
    address: "Address ng negosyo",
    line1: "Address line 1",
    line2: "Address line 2",
    addressHint: "Dapat tugma sa inyong BIR Certificate of Registration (Form 2303).",
    city: "Lungsod / bayan",
    province: "Lalawigan",
    zip: "ZIP code",
    taxType: "Uri ng buwis",
    taxUnset: "Hindi pa naitakda",
    tax_vat_registered: "VAT-registered",
    tax_non_vat: "Non-VAT",
    tax_vat_exempt: "VAT-exempt",
    vatExempt: "Organisasyong VAT-exempt",
    vatExemptHint: "Hihingin namin ang inyong BIR exemption certificate bago alisin ang VAT sa resibo.",
    vatExemptShort: "VAT-exempt",
    exemptionRef: "Reference ng exemption certificate",
    proof_pending: "hinihintay ang patunay",
    proof_verified: "beripikado",
    proof_rejected: "tinanggihan ang patunay",
    saved: "Na-save ang detalye ng billing. Gagamitin ito sa susunod na opisyal na resibo.",
    loadError: "Hindi ma-load ang detalye ng billing.",
    emptyTitle: "Idagdag ang detalye ng billing",
    emptyBody: "Lalabas sa opisyal na resibo ang inyong rehistradong pangalan, TIN at address.",
    errors: {
      name: "Ilagay ang rehistradong pangalan.",
      tin: "Maglagay ng tamang TIN (hal. 008-412-773-000).",
      email: "Maglagay ng tamang email.",
      line1: "Ilagay ang address ng kalye.",
      city: "Ilagay ang lungsod o bayan.",
    },
  },
  invoices: {
    title: "Mga invoice at opisyal na resibo",
    search: "Maghanap ng invoice…",
    number: "Blg. ng invoice",
    date: "Petsa",
    description: "Paglalarawan",
    amount: "Halaga",
    status: "Status",
    actions: "Mga aksyon",
    inclTax: "kasama ang {{tax}} {{label}}",
    payTitle: "Bayaran ang invoice {{number}}",
    payAmount: "Magbayad ng {{amount}}",
    or: "OR {{number}}",
    status_paid: "Bayad na",
    status_due: "Due sa {{date}}",
    status_overdue: "Lampas na mula {{date}}",
    status_failed: "Nabigo ang bayad",
    status_void: "Void",
    status_draft: "Draft",
    payNow: "Magbayad ngayon",
    pdf: "PDF",
    paid: "Bayad na ang invoice. Salamat!",
    loadError: "Hindi ma-load ang mga invoice.",
    emptyTitle: "Wala pang invoice",
    emptyBody: "Lalabas dito ang mga invoice at opisyal na resibo pagkatapos ng unang bayad.",
    noMatchTitle: "Walang tugmang invoice",
    noMatchBody: "Subukan ang ibang numero o paglalarawan ng invoice.",
    clear: "I-clear ang paghahanap",
  },
  breakdown: {
    title: "Detalye ng paggamit",
    byAgent: "Ayon sa agent",
    byChannel: "Ayon sa channel",
    byFeature: "Ayon sa feature",
    feature: "Feature",
    features: { answer: "Mga sagot", workflow_summary: "Mga buod ng workflow" },
    agent: "Agent",
    channel: "Channel",
    answers: "Mga sagot",
    credits: "Mga mensahe",
    share: "Bahagi ng mga mensahe",
    total: "Kabuuan",
    loadError: "Hindi ma-load ang paggamit.",
    emptyTitle: "Wala pang paggamit ngayong cycle",
    emptyBody: "Lalabas dito ang mga sagot ng inyong mga assistant habang nangyayari.",
  },
  channels: {
    widget: "Website widget",
    messenger: "Facebook Messenger",
    webapp: "Web app",
    api: "API",
    mobile: "Mobile app",
    email: "Email",
    playground: "Playground",
  },
  export: {
    group: "Grupo",
    key: "Item",
    done: "Na-export ang ulat ng paggamit: {{file}}",
  },
};
